export default __webpack_public_path__ + "static/media/myImg.af2a8262.png";